var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createElement, memo, useEffect, useRef, useState } from '@max/max';
import { useMonitorEngineContext } from "@nibfe/mcp-monitor-sdk";
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Button from '@hfe/max-button';
import LImage from '@max/leez-image';
import Sensor from '@max/mbc-sensor';
import CitySelectionModal from '../city-selection-modal';
import LightUpCityShareModal from '../light-up-city-share-modal';
import FixedBar from '../fixed-bar';
import { CityOrderTaskStatus } from '@/types/cityOrderTask';
import { useCityOrderTask } from '@/hooks/useCityOrderTask';
import './index.scss';
import { useShare } from "@/hooks/useShare/useShare.web";
// import {PanCityCard} from  '../pan-city-card';
import SlideCard from '../slide-city-card';
import { rpx2px } from '@hfe/max-universal-unit-tool';
import { InviteType, ACTIVITY_OFFLINE_CODE } from '@/types/shared';
import { useInvite } from '@/hooks/useInvite';
import { getQueryParams, appendParams } from '@/utils/common';
import LightUpSuccessModal from '@/components/light-up-success-modal';
import { isWeixinMiniProgramOrWeixinWebview, getPlatformType, PlatformType } from '@nibfe/mkt-env-api';
import FreeCardDrawResultPopup from '@/components/free-card';
import FreeOrderResult from './free-order-result';
import { navigateTo } from '@max/meituan-uni-navigate';
import FreeCardFail from '@/components/free-card-fail';
import { getSafeAreaMarginTop } from "@max/meituan-uni-screenInfo";
import { RequestStatus } from "@/hooks/useRequest";
import ActivityInvalid from "../activity-invalid";
import { useOrderPopup } from '@/hooks/useOrderPopup';
import { useDebounce } from '@/hooks/useDebounce';
import { POPUP_ORDER, BID_MAP } from '@/const';
import { convertH5ToWebviewPath } from "@nibfe/mkt-navigate-api";
import { isH5URL } from '@/utils/common';
import { KNB } from '@nibfe/mkt-common-utils';
const isWeb = true;
import msi from '@/utils/msi';
export const DYNAMIC_LIST_SCENE_TOKEN = 'dd-9cbc1c31cfbf2bba';
const CityOrderTask = (props) => {
    const { lightUpCityConfig: { taskId: lightUpTaskTaskId, descText: lightUpDescText, shareConfig, headerImgUrl = 'https://p0.meituan.net/ingee/058eaf5280554ae2c483859fcb0583bb5230.png' }, cityOrderTaskId, activityId, fixedBarTop = 100, gotoOrderUrlInWX, gotoOrderUrlInMt, freeCardShareConfig, onFirstRequestFinish, freeCardDesc, inTeam, onGoToTeamRankingAnchor, cityListData = [] } = props;
    // console.log('cityListData', cityListData);
    const ctx = useMonitorEngineContext();
    const { inviterType, leaderId, 
    // 邀请人id
    cityId: inviterCityId, lastWishTime: inviterLastWishTime, hotelchannel } = getQueryParams(ctx) || {};
    const moduleId = ctx._moduleId;
    const [targetY, setTargetY] = useState(0);
    const [displayCityList, setDisplayCityList] = useState([]);
    const [slideCityInfo, setSlideCityInfo] = useState(null);
    const [isShowModal, setIsShowModal] = useOrderPopup(false, POPUP_ORDER.INVITE_LIGHT_UP);
    // const [isShowModal, setIsShowModal] = useState(false);
    const [selectCityInfo, setSelectCityInfo] = useState(null);
    const [taskStatus, setTaskStatus] = useState(CityOrderTaskStatus.init);
    const [freeOrderInfo, setFreeOrderInfo] = useState(undefined);
    const [isShowFixedBar, setIsShowFixedBar] = useOrderPopup(false, POPUP_ORDER.FIXED_BAR, 1500);
    const [selectCityIds, setSelectCityIds] = useState([]);
    const anchorRef = useRef(null);
    const anchorSencorRef = useRef(null);
    const isPannelShown = useRef(false); // 横幅是否已经展示了
    const isPannelClosed = useRef(false); // 横幅是否被关闭
    const { shareWXCard } = useShare(props.operationOptions.shareType);
    const isInWX = isWeixinMiniProgramOrWeixinWebview();
    const { getCityOrderTask, requestStatus, remainDrawTimes, remainLightTimes, drawStatus, orderInfo, cityInfoList, lightCityInfo, optionalCityList, handleToChangeCity, isCityModalVisible, setCityModalVisible, handleDraw, isDrawResultModalVisible, setIsDrawResultModalVisible, setLightUpCityModalVisible, isLightUpCityModalVisible, lockWishLightUpCity, isDrawResultFailModalVisible, setIsDrawResultFailModalVisible, hasHotelOrder, isFirstRequestFinish, setIsFirstRequestFinish, isNetWorkErrorRender, winningOrderInfo, cityOrderRequestCode } = useCityOrderTask({
        activityId,
        taskId: cityOrderTaskId,
        onFirstRequestFinish
    });
    const { requestStatus: inviteResStatus, doInvite } = useInvite({
        activityId,
        taskId: lightUpTaskTaskId
    });
    const handleDebounceCityChanged = useDebounce((cityInfo) => {
        var _a;
        if (cityInfo) {
            console.log('emit cityChanged', cityInfo.cityId, cityInfo.cityName);
            (_a = props === null || props === void 0 ? void 0 : props._communication) === null || _a === void 0 ? void 0 : _a.emit('cityChanged', {
                value: cityInfo.cityId,
                title: cityInfo.cityName
            });
        }
    }, 200);
    const cityOrderAnchorKey = `cityOrderTask_${moduleId}`;
    let safeMarginTop = getSafeAreaMarginTop();
    useEffect(() => {
        var _a, _b;
        (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx._uiInteractionAPI) === null || _a === void 0 ? void 0 : _a.anchor) === null || _b === void 0 ? void 0 : _b.addAnchor(cityOrderAnchorKey, moduleId, {
            ref: anchorRef,
            anchorRelativeRootModulePositionY: targetY
        });
    }, [ctx, moduleId, cityOrderAnchorKey, targetY]);
    const goToAnchor = (anchorKey) => {
        var _a, _b;
        (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx._uiInteractionAPI) === null || _a === void 0 ? void 0 : _a.anchor) === null || _b === void 0 ? void 0 : _b.scrollToAnchor({
            anchorKey,
            animated: true
        });
    };
    const closePannel = () => {
        var _a;
        isPannelClosed.current = true;
        (_a = ctx === null || ctx === void 0 ? void 0 : ctx._topPanelAPI) === null || _a === void 0 ? void 0 : _a.setVisible({
            visible: false
        });
    };
    // 如果存在抽奖次数，则展示弹窗
    const handleGoAnchor = () => {
        goToAnchor(cityOrderAnchorKey);
        // ctx?._topPanelAPI?.setVisible({ visible: false });
    };
    const showPannel = (top = safeMarginTop, isOrderExist = false) => {
        if (!(ctx === null || ctx === void 0 ? void 0 : ctx._topPanelAPI))
            return;
        if (isPannelClosed.current)
            return; // 如果处于关闭状态，则不展示
        if (isPannelShown.current)
            return; // 如果处于打开状态，则不更新
        ctx._topPanelAPI.setTop(0);
        ctx._topPanelAPI.setPanelHeight('300rpx');
        ctx._topPanelAPI.setContent(<FixedBar remainDrawTimes={remainDrawTimes} isOrderExist={isOrderExist} onGoAnchor={handleGoAnchor} onClose={closePannel} onAppear={() => {
            isPannelShown.current = true;
        }} marginTop={top}/>);
        ctx._topPanelAPI.setVisible({
            visible: true
        });
    };
    const onAnchorLayout = e => {
        var _a, _b;
        if (!(ctx === null || ctx === void 0 ? void 0 : ctx._uiInteractionAPI))
            return;
        if (!anchorRef.current)
            return;
        const topY = ((_b = (_a = e === null || e === void 0 ? void 0 : e.nativeEvent) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.y) || 10;
        setTargetY(topY);
    };
    const handleModalClose = () => {
        setIsShowModal(false);
    };
    const handleCityChange = (cityInfo) => __awaiter(void 0, void 0, void 0, function* () {
        if (cityInfo) {
            setSelectCityInfo(cityInfo);
            setLightUpCityModalVisible(true); // 打开第二步弹窗
            // await lockWishLightUpCity(cityInfo.cityId);
        }
    });
    const handleToShareWish = () => {
        // setLightUpCityModalVisible(true);
        lightUpShare(slideCityInfo);
    };
    // 去下单
    const jumpToOrder = () => {
        if (!slideCityInfo)
            return;
        const { cityId, cityName } = slideCityInfo;
        if (isInWX) {
            // 微信小程序跳转
            if (!gotoOrderUrlInWX)
                return;
            const platform = getPlatformType();
            const url = appendParams(gotoOrderUrlInWX, {
                cityId: String(cityId),
                cityName: cityName || '',
                forceSelectedCityId: String(cityId),
                forceSelectedCityName: cityName || ''
            });
            const webviewUrl = platform === PlatformType.mtMinaWebview
                // 对美团小程序有特殊逻辑，使用酒小的WebView打开
                ? isH5URL(url) ? `/hotel/pages/h5/index?q=${encodeURIComponent(url)}` : url : convertH5ToWebviewPath(url, platform);
            return navigateTo({
                url: webviewUrl,
                _web: {
                    miniProgramNative: true
                }
            });
        }
        // app、h5跳转
        if (!gotoOrderUrlInMt)
            return;
        const seg = gotoOrderUrlInMt.indexOf('?') > -1 ? '&' : '?';
        const jumUrl = `${props.gotoOrderUrlInMt}${seg}cityId=${cityId}&cityName=${cityName}`;
        navigateTo({
            url: jumUrl
        }).then(() => {
            refreshData();
        }).catch(() => {
            refreshData();
        });
    };
    const lightUpShare = (lightUpCityInfo) => {
        const { userId, token } = ctx._runtimeInfo.commonParams || {};
        const { cityId, lastWishTime } = lightUpCityInfo;
        shareWXCard({
            params: {
                leaderId: userId,
                cityId,
                lastWishTime,
                inviterType: InviteType.INVITE_BRIGHT_CITY,
                shareTime: Date.now()
            },
            shareConfig
        });
    };
    const onLightUpShareHandle = (lightUpCityInfo) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        const { cityId } = lightUpCityInfo;
        const res = yield lockWishLightUpCity(cityId);
        const { isSuccess, data } = res;
        let isShareSuccess = false;
        if (isSuccess && data) {
            const { lightCityInfo } = data;
            const targetWishCity = lightCityInfo.find((item) => String(item.cityId) === String(cityId));
            if (targetWishCity && targetWishCity.lastWishTime) {
                // lastWishTime为必传参数
                const { lastWishTime } = targetWishCity;
                isShareSuccess = true;
                lightUpShare({
                    cityId,
                    lastWishTime
                });
            }
        }
        if (!isShareSuccess) {
            (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx._uiInteractionAPI) === null || _a === void 0 ? void 0 : _a.toast) === null || _b === void 0 ? void 0 : _b.show({
                content: '网络开小差了，请重试~'
            });
            (_d = (_c = ctx._raptorReport).monitorReportLog) === null || _d === void 0 ? void 0 : _d.call(_c, '许愿城市分享失败', null, {
                level: 'warn',
                category: 'Error',
                tags: {
                    cityId,
                    leaderId,
                    inviterType: InviteType.INVITE_BRIGHT_CITY,
                    data: JSON.stringify(data)
                }
            });
        }
        handleMCLxReport(BID_MAP.SHARE_MC);
    });
    const onShareFreeCard = () => {
        const { userId, token } = ctx._runtimeInfo.commonParams || {};
        shareWXCard({
            params: {
                leaderId: userId,
                shareTime: Date.now(),
                invite_source: 'free_card'
            },
            shareConfig: freeCardShareConfig
        });
    };
    const handleSlideEnd = (cityInfo) => {
        setSlideCityInfo(cityInfo);
        handleDebounceCityChanged(cityInfo);
    };
    const onLightUpModalCityPress = () => {
        goToAnchor(cityOrderAnchorKey);
        setIsShowModal(false);
    };
    const onTeamPress = () => {
        onGoToTeamRankingAnchor();
    };
    // 未点亮城市点击下单
    const handleUnLightUpOrderPress = () => {
        var _a, _b;
        (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx._uiInteractionAPI) === null || _a === void 0 ? void 0 : _a.toast) === null || _b === void 0 ? void 0 : _b.show({
            content: '先邀请好友点亮城市吧~'
        });
    };
    useEffect(() => {
        const inviteUser = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            const isInvite = Number(inviterType) === InviteType.INVITE_BRIGHT_CITY && leaderId;
            if (isInvite) {
                const { userId } = ctx._runtimeInfo.commonParams || {};
                // 客态点亮城市
                if (userId) {
                    const result = yield doInvite({
                        leaderId,
                        followerId: userId,
                        cityId: inviterCityId,
                        lastWishTime: inviterLastWishTime
                    });
                    if (result.success) {
                        setIsShowModal(true);
                    }
                    else {
                        const { code } = result;
                        let showMessage = '助力点亮失败，请稍后再试';
                        if (String(code) === '10057') {
                            showMessage = '助力已达到限度啦~明天再来吧';
                        }
                        if (String(code) === '10061') {
                            showMessage = '助力失败，不能给自己战队助力';
                        }
                        (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx._uiInteractionAPI) === null || _a === void 0 ? void 0 : _a.toast) === null || _b === void 0 ? void 0 : _b.show({
                            content: showMessage
                        });
                    }
                }
            }
        });
        if (!isFirstRequestFinish)
            return;
        inviteUser();
        onFirstRequestFinish && onFirstRequestFinish();
        setIsFirstRequestFinish(false);
    }, [isFirstRequestFinish, lightCityInfo]);
    useEffect(() => {
        if (isDrawResultModalVisible && orderInfo) {
            const showFreeOrderInfo = {
                hotelName: orderInfo.hotelOrderTitle,
                obtainAmount: orderInfo.hotelOrderPayMoney,
                checkOutTime: orderInfo.createOrderTime
            };
            setFreeOrderInfo(showFreeOrderInfo);
        }
    }, [isDrawResultModalVisible, orderInfo]);
    // 页面进入逻辑
    useEffect(() => {
        if (winningOrderInfo) {
            // 抽中免单，展示中奖
            setTaskStatus(CityOrderTaskStatus.drawSuccess);
        }
        else if (remainDrawTimes > 0 && inTeam) {
            // 存在抽奖次数
            const isOrderExist = hasHotelOrder;
            setIsShowFixedBar(true);
            // 如果抽奖次数大于0，但是没有订单，仍然需要去下单
            setTaskStatus(isOrderExist ? CityOrderTaskStatus.waitingDraw : CityOrderTaskStatus.init);
        }
        else if (hasHotelOrder) {
            // 没有抽奖次数，但是有订单的情况，则为抽奖次数已用完
            setTaskStatus(CityOrderTaskStatus.waitingDraw);
        }
        else {
            // 没有订单信息，则展示去下单
            setTaskStatus(CityOrderTaskStatus.init);
        }
        const selectCityIdArray = lightCityInfo.map(item => String(item.cityId));
        cityInfoList.forEach(item => {
            selectCityIdArray.push(String(item.cityId));
        });
        setSelectCityIds(selectCityIdArray);
        const unLightUpCity = lightCityInfo.filter(item => !item.display);
        const lightUpCityAlready = lightCityInfo.filter(item => item.display);
        const lightUpCityList = [...unLightUpCity, ...lightUpCityAlready];
        const finalDisplayCityList = [...cityInfoList];
        // 将 finalDisplayCityList插入到第二个位置，确保许愿城市展示在中间
        finalDisplayCityList.splice(1, 0, ...lightUpCityList);
        setDisplayCityList(finalDisplayCityList);
    }, [winningOrderInfo, cityInfoList, lightCityInfo, hasHotelOrder]);
    useEffect(() => {
        if (isShowFixedBar) {
            const finalTop = Math.max(safeMarginTop, fixedBarTop);
            showPannel(finalTop, hasHotelOrder);
        }
        else {
            ctx._topPanelAPI.setVisible({
                visible: false
            });
        }
    }, [isShowFixedBar]);
    const refreshData = useDebounce(() => {
        getCityOrderTask({
            isNetWorkErrorRender: true
        }).then(res => {
            res && res.isSuccess && (onFirstRequestFinish === null || onFirstRequestFinish === void 0 ? void 0 : onFirstRequestFinish());
        });
    }, 200);
    function onVisibilityChange() {
        if (isWeb && document && document.visibilityState === 'visible') {
            refreshData();
        }
    }
    useEffect(() => {
        var _a;
        if (true) {
            // 判断标准KNB容器
            const isStandardKNB = /KNB\//i.test(navigator.userAgent) && /MSI\//i.test(navigator.userAgent);
            if (isStandardKNB) {
                (_a = msi === null || msi === void 0 ? void 0 : msi.setNavigationBarHidden) === null || _a === void 0 ? void 0 : _a.call(msi, {
                    flag: 1
                });
            }
            else {
                KNB.setNavigationBarHidden({
                    flag: 1
                });
            }
            if (document) {
                document.addEventListener('visibilitychange', onVisibilityChange);
                return () => {
                    document.removeEventListener('visibilitychange', onVisibilityChange);
                };
            }
        }
        return () => { };
    }, []);
    useEffect(() => {
        var _a;
        (_a = ctx._eventInstance) === null || _a === void 0 ? void 0 : _a.on('BASE_ENGINE.ON_PAGE_RELOAD', refreshData);
        return () => {
            var _a;
            (_a = ctx._eventInstance) === null || _a === void 0 ? void 0 : _a.off('BASE_ENGINE.ON_PAGE_RELOAD', refreshData);
        };
    }, []);
    const lxCommonParams = {
        activity_id: activityId,
        hotel_channel: hotelchannel,
        leader_id: Number(leaderId),
        invite_type: inviterType
    };
    const handleMCLxReport = (bid, extraVal) => {
        const valLab = extraVal ? Object.assign(Object.assign({}, lxCommonParams), extraVal) : lxCommonParams;
        ctx._LXReport.mcReport(bid, {
            valLab
        });
    };
    const handleMVLxReport = (bid, extraVal) => {
        const valLab = extraVal ? Object.assign(Object.assign({}, lxCommonParams), extraVal) : lxCommonParams;
        ctx._LXReport.mvReport(bid, {
            valLab
        });
    };
    if (requestStatus === RequestStatus.ERROR && isNetWorkErrorRender) {
        return <ActivityInvalid type="error" btnProps={{
            text: '重试',
            onPress: () => __awaiter(void 0, void 0, void 0, function* () {
                const res = yield getCityOrderTask({
                    isNetWorkErrorRender: true
                });
                res && res.isSuccess && (onFirstRequestFinish === null || onFirstRequestFinish === void 0 ? void 0 : onFirstRequestFinish());
            })
        }} text="网络走丢了，请重试" showBtn/>;
    }
    if (cityOrderRequestCode === ACTIVITY_OFFLINE_CODE) {
        return <ActivityInvalid type="error" text="活动已结束，请持续关注美团酒店活动～"/>;
    }
    return <Sensor className="city-order-task-wrap" ref={anchorSencorRef} onLayout={onAnchorLayout}>
      
      <FreeOrderResult x-if={taskStatus === CityOrderTaskStatus.drawSuccess} winningOrderInfo={winningOrderInfo} onShareFreeCard={onShareFreeCard}/>
      <View x-else ref={anchorRef} className="city-order-task-module" style={{
        height: '724rpx',
        overflow: 'hidden',
        borderRadius: '36rpx'
    }}>
        <LImage className="city-order-task-module__bg" source={{
        uri: "https://p0.meituan.net/ingee/2f5dfa35b99b7e93752910cd8444eb9310020.png"
    }} style={{
        width: '702rpx',
        height: '705rpx'
    }} width={rpx2px(702)} height={rpx2px(705)} resizeMode='cover' borderRadius={rpx2px(36)}>
          <LImage className="city-order-task-module__header-img" source={{
        uri: headerImgUrl
    }} style={{
        width: "428rpx",
        height: "36rpx",
        marginTop: '32rpx'
    }} borderRadius={0}/>
          <Text x-if={!(slideCityInfo === null || slideCityInfo === void 0 ? void 0 : slideCityInfo.isWishCity)} className="city-order-task-module__light-text">{lightUpDescText || '下单即可获得抽免单机会哦~'}</Text>
          <Text x-if={(slideCityInfo === null || slideCityInfo === void 0 ? void 0 : slideCityInfo.isWishCity) && !slideCityInfo.display} className="city-order-task-module__light-text">分享好友即可点亮心愿城市哦～</Text>
          <Text x-if={(slideCityInfo === null || slideCityInfo === void 0 ? void 0 : slideCityInfo.isWishCity) && slideCityInfo.display} className="city-order-task-module__light-text">心愿已点亮，还有<Text style={{
        color: "#248120"
    }}>{slideCityInfo === null || slideCityInfo === void 0 ? void 0 : slideCityInfo.timeLeft}</Text>天失效，快在心愿地下单赢免单吧~</Text>
          <SlideCard cityList={displayCityList} onSlideEnd={handleSlideEnd}/>
          
          <View x-if={taskStatus === CityOrderTaskStatus.waitingDraw} className="city-order-task-module__buttons" style={{
        width: '654rpx'
    }}>
            <Button x-if={remainDrawTimes > 0} className="city-order-task-module__order-button" onPress={handleDraw} style={{
        width: '654rpx'
    }}>
              <LImage source={{
        uri: 'https://p0.meituan.net/ingee/b06d7416bf94de90af194cced7638caa19901.png'
    }} style={{
        width: '654rpx',
        height: '90rpx'
    }} borderRadius={0}>
                
              </LImage>
            </Button>
            <Button x-else className="city-order-task-module__order-button" style={{
        opacity: 0.5,
        width: '654rpx'
    }}>
              <Text className="city-order-task-module__order-text" style={{
        color: '#C2C2C2'
    }}>{'抽奖次数已用完'}</Text>
            </Button>
            <View className="city-order-task-module__order-tip">
              <View style={{
        // width: '167rpx',
        height: '38rpx',
        backgroundColor: '#FF2D19',
        borderTopLeftRadius: '25rpx',
        borderTopRightRadius: '19rpx',
        borderBottomRightRadius: '19rpx',
        borderBottomLeftRadius: '6rpx',
        padding: '0rpx 10rpx',
        zIndex: 1
    }}>
                <Text x-if={remainDrawTimes > 0} className="city-order-task-module__order-tip-text">还有{remainDrawTimes}次抽奖资格</Text>
                <Text x-else className="city-order-task-module__order-tip-text">组队打call可赢次数</Text>
              </View>
            </View>
          </View>
          <View x-else className="city-order-task-module__buttons">
            
            <View x-if={(slideCityInfo === null || slideCityInfo === void 0 ? void 0 : slideCityInfo.isWishCity) && !slideCityInfo.display} className="city-order-task-module__wish-button-wrap">
              <Button className="city-order-task-module__wish-button" onPress={() => {
        handleToShareWish();
        handleMCLxReport(BID_MAP.SHARE_MC);
    }} style={{
        backgroundColor: '#FFF200',
        borderWidth: 0,
        borderColor: '#ffffff00'
    }}>
                <Text className="city-order-task-module__wish-text" style={{
        color: '#111'
    }}>去分享</Text>
              </Button>
            </View>
            
            <Sensor x-else once className="city-order-task-module__wish-button-wrap" onAppear={() => handleMVLxReport(BID_MAP.WISH_CITY_MV)}>
              <Button 
    // x-if={remainLightTimes > 0}
    className="city-order-task-module__wish-button" onPress={() => {
        handleToChangeCity();
        handleMCLxReport(BID_MAP.WISH_CITY_MC);
    }} style={{
        opacity: remainLightTimes > 0 ? 1 : 0.5,
        borderColor: remainLightTimes > 0 ? '#1E8A19' : '#C2C2C2'
    }}>
                <LImage source={{
        uri: remainLightTimes ? "https://p0.meituan.net/ingee/ae81926cdd6d4fbf2a27311722e23f001181.png" : 'https://img.meituan.net/makerjiulv/b628c74bebe73f74285ec87433fe32d51101.png'
    }} style={{
        width: '28.5rpx',
        height: '30.5rpx',
        marginRight: '6.2rpx'
    }} borderRadius={0}/>
                <Text className="city-order-task-module__wish-text" style={{
        color: remainLightTimes > 0 ? '#1E8A19' : '#C2C2C2'
    }}>许愿城市</Text>
              </Button>
              
              <View className="city-order-task-module__wish-tip">
                <View className="city-order-task-module__wish-wrap">
                  <Text x-if={remainLightTimes > 0} className="city-order-task-module__wish-tip-text">还有{remainLightTimes}次机会</Text>
                  <Text x-else className="city-order-task-module__wish-tip-text">明日再来看看</Text>
                </View>
              </View>
            </Sensor>
            
            <View x-if={(slideCityInfo === null || slideCityInfo === void 0 ? void 0 : slideCityInfo.isWishCity) && !slideCityInfo.display} className="city-order-task-module__order-button-wrap">
              <Button className="city-order-task-module__order-button" onPress={handleUnLightUpOrderPress} style={{
        opacity: 0.5
    }}>
                <Text x-if={slideCityInfo} className="city-order-task-module__order-text" style={{
        color: '#C2C2C2'
    }}>去{slideCityInfo === null || slideCityInfo === void 0 ? void 0 : slideCityInfo.cityName}下单</Text>
              </Button>
            </View>
            
            <Sensor x-else className="city-order-task-module__order-button-wrap" onAppear={() => handleMVLxReport(BID_MAP.GO_TO_ORDER_MV, {
        city_id: slideCityInfo === null || slideCityInfo === void 0 ? void 0 : slideCityInfo.cityId,
        city_name: slideCityInfo === null || slideCityInfo === void 0 ? void 0 : slideCityInfo.cityName
    })}>
              <Button className="city-order-task-module__order-button" onPress={() => {
        handleMCLxReport(BID_MAP.GO_TO_ORDER_MC, {
            city_id: slideCityInfo === null || slideCityInfo === void 0 ? void 0 : slideCityInfo.cityId,
            city_name: slideCityInfo === null || slideCityInfo === void 0 ? void 0 : slideCityInfo.cityName
        });
        jumpToOrder();
    }}>
                <LImage source={{
        uri: 'https://img.meituan.net/makerjiulv/237a3fd123dd6473b35e49445224946a6533.png'
    }} style={{
        width: '393rpx',
        height: '90rpx'
    }} borderRadius={0}>
                  <Text x-if={slideCityInfo} className="city-order-task-module__order-text">去{slideCityInfo === null || slideCityInfo === void 0 ? void 0 : slideCityInfo.cityName}下单</Text>
                </LImage>
              </Button>
              <View className="city-order-task-module__order-tip">
                <View style={{
        // width: '167rpx',
        height: '38rpx',
        backgroundColor: '#FF2D19',
        borderTopLeftRadius: '25rpx',
        borderTopRightRadius: '19rpx',
        borderBottomRightRadius: '19rpx',
        borderBottomLeftRadius: '6rpx',
        padding: '0rpx 10rpx',
        zIndex: 1
    }}>
                  <Text className="city-order-task-module__order-tip-text">下单即可抽免单</Text>
                </View>
              </View>
            </Sensor>
          </View>
        </LImage>
      </View>
      
      <CitySelectionModal x-if={isCityModalVisible} visible={isCityModalVisible} onCityChange={handleCityChange} cityList={cityListData} selectCityIds={selectCityIds} onClose={() => setCityModalVisible(false)}/>
      
      <LightUpCityShareModal x-if={isLightUpCityModalVisible} visible={isLightUpCityModalVisible} onClose={() => setLightUpCityModalVisible(false)} lightCityInfo={selectCityInfo} onShare={onLightUpShareHandle} onBack={() => setCityModalVisible(true)}/>
      <LightUpSuccessModal x-if={isShowModal} visible={isShowModal} onClose={handleModalClose} onCityPress={onLightUpModalCityPress} onTeamPress={() => {
        setIsShowModal(false);
        onTeamPress();
    }}/>
      
      <FreeCardDrawResultPopup x-if={isDrawResultModalVisible} visible={isDrawResultModalVisible} onClose={() => setIsDrawResultModalVisible(false)} freeOrderCardExtra={freeOrderInfo} onShareFreeCard={() => {
        handleMCLxReport(BID_MAP.SHARE_MC);
        onShareFreeCard();
    }} freeCardDesc={freeCardDesc}/>
      <FreeCardFail x-if={isDrawResultFailModalVisible} visible={isDrawResultFailModalVisible} onClose={() => setIsDrawResultFailModalVisible(false)} inTeam={inTeam} onTeamPress={() => {
        setIsDrawResultFailModalVisible(false);
        onTeamPress();
    }}/>
    </Sensor>;
};
export default memo(CityOrderTask);
